import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import { DataTableColumnHeader } from "@/components/ui";
import { formatDate } from "@/lib/utils/format";
import type { DashboardPinnedMatter } from "@/lib/types";
import type { ColumnDef } from "@tanstack/react-table";

export const getDashboardPinnedMattersColumns = (): ColumnDef<
  DashboardPinnedMatter,
  string
>[] =>
  [
    {
      accessorFn: (row) => row.matter.title ?? "",
      id: "Matter",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.matter.title ?? "-",
      enableHiding: false,
    },
    {
      accessorFn: (row) =>
        row.matter.clients.map((client) => client.name).join(", "),
      id: "Client",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) =>
        row.original.matter.clients.map((client) => client.name).join(", ") ||
        "-",
    },
    {
      accessorFn: (row) => row.matter.incidentType?.label,
      id: "Incident Type",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => getIncidentTypeLabel(row.original.matter.incidentType),
    },
    {
      accessorFn: (row) => row.matter.status.label,
      id: "Case Status",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.matter.status.label,
    },
    {
      accessorKey: "dateCreated",
      id: "Pinned At",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) =>
        row.original.dateCreated ? formatDate(row.original.dateCreated) : "-",
    },
  ] as ColumnDef<DashboardPinnedMatter, string>[];
